import { Card, Stack } from "react-bootstrap";
import { motion } from "framer-motion";

const shimmerAnimation = {
  initial: { backgroundPosition: "-200% 0" },
  animate: { 
    backgroundPosition: "200% 0",
    transition: { 
      duration: 1.5,
      repeat: Infinity,
      ease: "linear"
    }
  }
};

const shimmerStyle = {
  background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
  backgroundSize: "200% 100%",
  animation: "shimmer 1.5s infinite linear",
};

const StoreCardSkeleton = () => {
  return (
    <Card className="h-100 shadow-sm border-0 overflow-hidden">
      <motion.div
        style={{
          height: "200px",
          ...shimmerStyle
        }}
        variants={shimmerAnimation}
        initial="initial"
        animate="animate"
      />
      
      <Card.Body className="p-3">
        <Stack gap={2}>
          <motion.div
            style={{
              height: "24px",
              width: "80%",
              borderRadius: "4px",
              ...shimmerStyle
            }}
            variants={shimmerAnimation}
            initial="initial"
            animate="animate"
          />
          
          <motion.div
            style={{
              height: "16px",
              width: "60%",
              borderRadius: "4px",
              ...shimmerStyle
            }}
            variants={shimmerAnimation}
            initial="initial"
            animate="animate"
          />
          
          <Stack direction="horizontal" gap={2} className="mt-2">
            <motion.div
              style={{
                height: "20px",
                width: "20px",
                borderRadius: "4px",
                ...shimmerStyle
              }}
              variants={shimmerAnimation}
              initial="initial"
              animate="animate"
            />
            <motion.div
              style={{
                height: "20px",
                width: "40%",
                borderRadius: "4px",
                ...shimmerStyle
              }}
              variants={shimmerAnimation}
              initial="initial"
              animate="animate"
            />
          </Stack>
          
          <Stack direction="horizontal" gap={2} className="mt-1">
            <motion.div
              style={{
                height: "20px",
                width: "20px",
                borderRadius: "4px",
                ...shimmerStyle
              }}
              variants={shimmerAnimation}
              initial="initial"
              animate="animate"
            />
            <motion.div
              style={{
                height: "20px",
                width: "30%",
                borderRadius: "4px",
                ...shimmerStyle
              }}
              variants={shimmerAnimation}
              initial="initial"
              animate="animate"
            />
          </Stack>
        </Stack>
      </Card.Body>
    </Card>
  );
};

export default StoreCardSkeleton;
